// connect action creators to a specific reducer's dispatch
// don't modify the actions, because it's read only if it's imported
export const connectActionCreators = (actions, dispatch, oldState) => {
  let bindActions = Object.assign({}, actions);
  for (const action in bindActions) {
    bindActions[action] = bindActions[action](dispatch, oldState);
  }
  return bindActions;
};
